import {Injectable} from '@angular/core'

const DEFAULTTEXT = 'Loading...'
const DONETEXT = 'Done'

@Injectable()
export class LoaderService {
  info: string = DEFAULTTEXT
  loading: boolean = false
  progress: number = 0

  constructor() {}

  start(_info: string = DEFAULTTEXT, _progress: number = 0) {
    this.loading = true
    this.info = _info
  }

  update(_info: string, _progress: number = 0) {
    this.info = _info
    this.progress = _progress
  }

  stop(_info: string = DONETEXT, delay = 600) {
    this.info = _info
    setTimeout(() => {
      this.loading = false
    }, delay)
  }
}



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/ui-shared/loader/loader.service.ts